import { render, staticRenderFns } from "./VerificationCard.vue?vue&type=template&id=0e47306a&lang=pug"
import script from "./VerificationCard.vue?vue&type=script&lang=js"
export * from "./VerificationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports